import React from 'react';
import HighCharts from 'highcharts';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';
import ScreenPrintEventListenerUtils from 'utils/screen-print-utils';

import { MIN_RIT, MAX_RIT } from 'resources/common-values';

import InitialChartOptions from './initial-chart-options.json';

const printHeight = 50;
const printWidth = 80;

export default CreateReactClass({
    displayName: 'RainbowChart',

    propTypes: {
        chartContainerId: PropTypes.string.isRequired,
        percentile: PropTypes.number,
    },
    chart: null,

    componentDidUpdate() {
        if (this.chart) {
            let percentileData = [
                {
                    y: this.props.percentile,
                },
            ];
            this.chart.series[5].setData(percentileData, true);
        }
    },

    shouldComponentUpdate(nextProps) {
        return this.props.percentile !== nextProps.percentile;
    },

    //<editor-fold desc="react life-cycle">
    componentDidMount() {
        this.chart = this.createChart();
        ScreenPrintEventListenerUtils.setUpEventListeners(this.redrawChartForPrint, this.resetChartAfterPrint);
    },

    componentWillUnmount() {
        ScreenPrintEventListenerUtils.tearDownEventListeners(this.redrawChartForPrint, this.resetChartAfterPrint);

        if (this.chart) {
            try {
                this.chart.destroy();
            } catch (e) {
                // Control the failure
                console.warn(e);
            }
        }
    },
    //</editor-fold>

    createChart() {
        HighCharts.SVGRenderer.prototype.symbols.invertedTriangle = function(x, y, w, h) {
            return ['M', w - 3, y + w / 2, 'l', (w / h) * 8, -h / 2, 'v', h];
        };
        //     don't want to render the chart
        //     until the container is there with the proper ID
        if (!__UNIT_TEST__ && document.getElementById(this.props.chartContainerId)) {
            let chart = HighCharts.chart(this.props.chartContainerId, {
                ...InitialChartOptions,
                chart: {
                    height: 50,
                    type: 'bar',
                    backgroundColor: 'transparent',
                },
                series: [
                    {
                        name: '81-100',
                        data: [0, 20],
                        color: '#157DD3',
                        showInLegend: false,
                    },
                    {
                        name: '61-80',
                        data: [0, 20],
                        color: '#57B229',
                        showInLegend: false,
                    },
                    {
                        name: '41-60',
                        data: [0, 20],
                        color: '#E8A929',
                        showInLegend: false,
                    },
                    {
                        name: '21-40',
                        data: [0, 20],
                        color: '#F2712B',
                        showInLegend: false,
                    },
                    {
                        name: '0-20',
                        data: [0, 20],
                        color: '#E2343C',
                        showInLegend: false,
                    },
                    {
                        type: 'scatter',
                        data: [
                            {
                                y: this.props.percentile,
                                marker: {
                                    states: {
                                        hover: {
                                            enabled: false,
                                        },
                                    },
                                    symbol: 'invertedTriangle',
                                    radius: 8,
                                    fillColor: '#000',
                                    enabled: this.props.percentile !== null,
                                },
                            },
                        ],
                        showInLegend: false,
                    },
                ],
            });

            this.chart = chart;
            return chart;
        }

        return null;
    },

    redrawChartForPrint() {
        if (this.chart.series) {
            // chart has initialized, so carry on with the redraw
            this.chart.setSize(printWidth, printHeight, false);
            this.chart.reflow();
        }
    },

    resetChartAfterPrint() {
        // chart.destroy() only destroys the chart data, not the HighCharts object itself.
        // hence why we check to see the series property, otherwise the HighCharts object
        // tries to destroy nothing.
        if (this.chart.series) {
            try {
                this.chart.destroy();
            } catch (e) {
                console.warn('destroying chart after print failed', e);
            }
            // Tear down listeners that have references to old chart
            ScreenPrintEventListenerUtils.tearDownEventListeners(this.redrawChartForPrint, this.resetChartAfterPrint);
        }

        setTimeout(() => {
            this.createChart();
        }, 1);

        ScreenPrintEventListenerUtils.setUpEventListeners(this.redrawChartForPrint, this.resetChartAfterPrint);
    },

    render() {
        const className = 'comparisons-rainbow-chart-container' + (this.props.percentile ? '' : ' no-data');
        return (
            <div className={className} style={{ width: '80%', opacity: this.props.percentile ? 1.0 : 0.25 }}>
                <div id={this.props.chartContainerId} key="comparisons-rainbow-chart"></div>
            </div>
        );
    },
});
